import { cva } from 'class-variance-authority';

import { type PostStatus } from '@/types/post';

export const statusDisplay: Record<PostStatus, string> = {
  open: 'Open',
  in_progress: 'Ongoing',
  completed: 'Completed',
  cancelled: 'Cancelled',
} as const;

export const statusVariants = cva('', {
  variants: {
    status: {
      open: 'text-brand-green',
      in_progress: 'text-orange-600',
      completed: 'text-blue-600',
      cancelled: 'text-red-500',
    },
  },
  defaultVariants: {
    status: 'open',
  },
});

export const maxDescriptionLength = 255;
